import { ContentType, request } from "../api";
import { baseParams } from "../common";

export const registration = async (data = {}, params = {}) => request({
  path: "/client-registration",
  method: "POST",
  body: { ...baseParams, ...data },
  type: ContentType.Json,
  format: "json",
  ...params,
});
